// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__30J9N","container":"styles_container__3sbl0","title":"styles_title__1uOXC","wrapper":"styles_wrapper__ygSh9","answer":"styles_answer__2S0HT"};